import { Injectable } from '@angular/core';

export enum EVENTS_BY {
  ALL,
  TODAY,
  SCHEDULED,
  ROOM,
  DEVICE
}

export enum EVENTS_FILTER {
  ALL,
  MY
}

export interface EventsUIContext {
  by: EVENTS_BY;
  filter: EVENTS_FILTER;
}

const INITIAL_STATE: EventsUIContext = {
  by: EVENTS_BY.ALL,
  filter: EVENTS_FILTER.ALL
}

const STORE_NAME = ['PROGRAMMING', 'QUICKSTARTS', 'EVENTS', 'UI'].join(':');

export const EVENTS_UI_ACTIONS = {
  SET_BY: `${STORE_NAME}:SET_BY`,
  SET_FILTER: `${STORE_NAME}:SET_FILTER`
}

const EVENTS_UI_ACTION_STRINGS = Object.keys(EVENTS_UI_ACTIONS).map(key => EVENTS_UI_ACTIONS[key]);

export function eventsUIReducer(state: EventsUIContext = INITIAL_STATE, {type, payload}): EventsUIContext {

  switch (type) {

    case EVENTS_UI_ACTIONS.SET_BY:
      return Object.assign({}, state, { by: parseInt(payload) });

    case EVENTS_UI_ACTIONS.SET_FILTER:
      return Object.assign({}, state, { filter: parseInt(payload) });

    default:
      return state;
  }
}

@Injectable()
export class EventsUIService { }



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/events/eventsUI.service.ts